import React, { useEffect, useState } from "react"
import { replaceS3Url } from "components/Common/ReplaceS3Url"
import { Link } from "react-router-dom"

const ShowThumbnail = ({ Notification }) => {
  const getFileExtension = url => {
    if (url && url !== "null" && url !== " ") {
      const ext = url.split(".").pop()
      let murl = ""

      if (url) {
        murl = replaceS3Url(url)
      } else {
        murl = url
      }

      if (ext.toLowerCase() === "pdf") {
        return (
          <div className="text-center">
            <i
              className="mdi mdi-file-pdf text-danger"
              style={{ fontSize: "40px" }}
            ></i>
          </div>
        )
      } else if (ext.toLowerCase() === "docx") {
        return (
          <div className="text-center">
            <i
              className="mdi mdi-file-document fs-1 text-primary"
              style={{ fontSize: "40px" }}
            ></i>
          </div>
        )
      } else if (
        ext.toLowerCase() === "jpeg" ||
        ext.toLowerCase() === "png" ||
        ext.toLowerCase() === "jpg"
      ) {
        return (
          <div className="">
            {url ? (
              <img
                src={murl.trim()}
                width={"100%"}
                alt="thumbnail"
                className="rounded-3"
              />
            ) : (
              <img src="" alt="" style={{ display: "none" }} />
            )}
          </div>
        )
      } else if (ext.toLowerCase() === "csv" || ext.toLowerCase() === "xlsx") {
        return (
          <div className="text-center">
            <i
              className="mdi mdi-file-excel text-primary"
              style={{ fontSize: "40px" }}
            ></i>
          </div>
        )
      } else {
        return (
          <div className="text-center">
            <i className="mdi mdi-file" style={{ fontSize: "40px" }}></i>
          </div>
        )
      }
    }
  }

  return (
    <div className="d-flex justify-content-start p-0 flex-wrap">
      {[
        Notification.file_attach,
        Notification.file_attach2,
        Notification.file_attach3,
      ].map((file, index) => {
        if (!file || file.trim() === "") return null
        const fileUrl = file
        const thumbnail = Notification[`thumbnail${index + 1}`] || file

        return (
          <div key={index} className="p-2">
            <Link
              to="/media-preview"
              state={{ fileurl: replaceS3Url(fileUrl) }}
              className="text-decoration-none"
              style={{
                display: "block",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                textAlign: "center",
                width: "175px",
                background: "#f9f9f9",
                cursor: "pointer",
                transition: "0.3s",
              }}
              title="Click to view file"
            >
              {getFileExtension(thumbnail)}
              <div
                style={{ fontSize: "12px", marginTop: "5px", color: "#555" }}
              >
                View
              </div>
            </Link>
          </div>
        )
      })}
    </div>
  )
}

export default ShowThumbnail
